import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { AttributionTracker, ATTRIBUTION_SOURCES, AttributionSource } from '@/utils/attribution';
import { trackEvent } from '@/analytics';

interface AttributionParams {
  source: string;
}

export const AttributionRedirect: React.FC = () => {
  const { source } = useParams<AttributionParams>();
  const history = useHistory();

  useEffect(() => {
    // Validate the source
    const validSource = source.toLowerCase() as AttributionSource;
    
    if (validSource in ATTRIBUTION_SOURCES) {
      // Set attribution
      AttributionTracker.setAttribution({
        source: validSource,
        medium: 'social',
        campaign: `${validSource}_redirect`
      });
      
      console.log(`📍 Attribution set from /${source} redirect`);
    } else {
      console.warn(`⚠️ Unknown attribution source: ${source}`);
    }

    // Redirect to home page after a brief moment
    // This allows time for attribution to be set
    setTimeout(() => {
      history.replace('/');
    }, 100);

  }, [source, history]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Welcome from {ATTRIBUTION_SOURCES[source as AttributionSource] || source}!</p>
        <p className="text-sm text-gray-500">Redirecting you to Moonscape...</p>
      </div>
    </div>
  );
};

// Component for the marketing site home page
export const MarketingHome: React.FC = () => {
  useEffect(() => {
    // Initialize attribution tracking on marketing site
    AttributionTracker.init();
  }, []);

  // Your existing marketing site content would go here
  return (
    <div>
      {/* Your marketing content */}
      <h1>Welcome to Moonscape</h1>
      <p>Your crypto tax tracker</p>
      
      {/* Attribution-aware download links */}
      <div className="flex space-x-4">
        <a 
          href="https://apps.apple.com/app/moonscape/id123456789"
          onClick={() => {
            const attribution = AttributionTracker.getAttribution();
            if (attribution) {
              // Track iOS app download with attribution
              trackEvent('iOS App Download', {
                source: attribution.source,
                campaign: attribution.campaign
              });
            }
          }}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg"
        >
          Download iOS App
        </a>
        
        <a 
          href="https://dashboard.moonscape.app/signup"
          onClick={() => {
            const attribution = AttributionTracker.getAttribution();
            // Pass attribution to dashboard via URL params
            if (attribution) {
              const url = new URL('https://dashboard.moonscape.app/signup');
              url.searchParams.set('utm_source', attribution.source);
              if (attribution.campaign) url.searchParams.set('utm_campaign', attribution.campaign);
              if (attribution.medium) url.searchParams.set('utm_medium', attribution.medium);
              window.location.href = url.toString();
              return false;
            }
          }}
          className="bg-green-600 text-white px-6 py-3 rounded-lg"
        >
          Start Web App
        </a>
      </div>
    </div>
  );
};